import { useSEO } from '@/hooks/useSEO';

export default function About() {
  useSEO(
    'About Us | Earning Calculators.Com',
    'Learn more about Earning Calculators.Com and our mission to empower the modern workforce with free, powerful financial tools.'
  );

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-headline text-4xl md:text-5xl font-bold tracking-tighter mb-6 text-center">
          About Earning Calculators.Com
        </h1>
        <div className="prose prose-lg mx-auto text-muted-foreground">
          <p>
            Earning Calculators.Com was founded with a single, clear mission: to empower the modern workforce with the financial tools and knowledge they need to thrive. We saw a gap in the financial landscape—while traditional finance focused on W-2 employees and large corporations, a new generation of creators, freelancers, gig workers, and online sellers were left to navigate a complex world of self-employment income, platform fees, and variable cash flow on their own.
          </p>
          <p>
            Our platform provides a comprehensive suite of over 40 (and growing!) free, easy-to-use financial calculators designed specifically for the unique challenges of the new economy. Whether you're an influencer calculating sponsorship rates, a rideshare driver estimating net profit after fuel costs, or an e-commerce seller determining your product's landed cost, we have a tool for you.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Our Philosophy</h2>
          <p>
            We believe that financial literacy is a right, not a privilege. Our calculators are designed to be intuitive, transparent, and powerful, breaking down complex financial concepts into simple, actionable insights. We want you to spend less time worrying about spreadsheets and more time doing what you do best—creating, building, and innovating.
          </p>
          <p>
            Every tool on Earning Calculators.Com is built on a foundation of meticulous research and real-world data, ensuring you get accurate and relevant estimates to guide your financial decisions.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Our Commitment</h2>
          <p>
            We are committed to keeping Earning Calculators.Com free and accessible to everyone. We will continue to expand our library of calculators, add new features, and provide high-quality content to help you navigate your financial journey. Thank you for trusting us to be a part of your success.
          </p>
        </div>
      </div>
    </div>
  );
}